import PageLayout from 'pages/StudentAssignments/PageLayout';
import PageProvider from 'pages/StudentAssignments/PageProvider';

const StudentAssignmentsPage = ({ ...props }) => {
    return (
        <PageProvider {...props}>
            <PageLayout {...props} />
        </PageProvider>
    );
};

export default StudentAssignmentsPage;
